// surveyCustomize.js
// Data and helpers backing the "Customize" entry in the brand switcher —
// a user-editable brand, as opposed to the fixed presets in surveyBrands.js.
export const CUSTOM_BRAND_ID = 'custom';

export const FONT_OPTIONS = [
  { id: 'raleway', label: 'Raleway (sans-serif)', value: "'Raleway', sans-serif" },
  { id: 'merriweather', label: 'Merriweather (serif)', value: "'Merriweather', serif" },
  { id: 'sifonn', label: 'Sifonn (display)', value: "'Sifonn', sans-serif" },
  { id: 'georgia', label: 'Georgia (serif)', value: "Georgia, 'Times New Roman', serif" },
  { id: 'courier', label: 'Courier (monospace)', value: "'Courier New', monospace" },
];

export const SCALE_STYLE_OPTIONS = [
  { id: 'individual', label: 'Individual buttons', segmented: false },
  { id: 'segmented', label: 'Connected strip', segmented: true },
];

export const DEFAULT_CUSTOM_CONFIG = {
  wordmark: 'Custom',
  tagline: 'Your Brand',
  colors: {
    primary: '#308273',
    success: '#2e7d32',
    info: '#1d6fa5',
    danger: '#c0392b',
    text: '#222222',
    page: '#ffffff',
  },
  font: 'raleway',
  scaleStyle: 'individual',
  autoAdvance: false,
  hideNavButtons: false,
};

// Picks black or white text for readable contrast against an arbitrary
// hex color, so users don't need to manually choose a 7th "text on primary"
// color just to keep buttons legible.
export function getContrastColor(hex) {
  const clean = (hex || '').replace('#', '');
  if (clean.length !== 6) return '#ffffff';
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111111' : '#ffffff';
}

export function fontValueFor(fontId) {
  const match = FONT_OPTIONS.find((f) => f.id === fontId);
  return match ? match.value : FONT_OPTIONS[0].value;
}

// WCAG 2.x relative luminance / contrast ratio, used to flag when a
// text/page color pairing wouldn't actually be readable.
function relativeLuminance(hex) {
  const clean = (hex || '').replace('#', '');
  if (clean.length !== 6) return 0;
  const toLinear = (channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const r = toLinear(parseInt(clean.slice(0, 2), 16));
  const g = toLinear(parseInt(clean.slice(2, 4), 16));
  const b = toLinear(parseInt(clean.slice(4, 6), 16));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function getContrastRatio(hexA, hexB) {
  const lA = relativeLuminance(hexA) + 0.05;
  const lB = relativeLuminance(hexB) + 0.05;
  return lA > lB ? lA / lB : lB / lA;
}

export const WCAG_AA_MIN_CONTRAST = 4.5;
